import Vue from 'vue'
import Router from 'vue-router'

const SCMUCaseSummaries = () => import( /* webpackChunkName: "scmuCaseSummaries" */ '@/components/SCMU/CaseSummaries')
const DMUCaseSummaries = () => import( /* webpackChunkName: "dmuCaseSummaries" */ '@/components/DMU/CaseSummaries')
const CICaseSummaries = () => import( /* webpackChunkName: "ciCaseSummaries" */ '@/components/CriticalIncidents/CriticalIncidents.vue')
const OIGRecommendations = () => import( /* webpackChunkName: "oigRecommendations" */ '@/components/Recommendations/Recommendations.vue')
const MIURecommendations = () => import( /* webpackChunkName: "miuRecommendations" */ '@/components/MIU/miuRecommendations.vue')

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: {
      name: 'DMUCaseSummaries'
    }
  },
  {
    path: '/dmu/caseSummaries',
    name: 'DMUCaseSummaries',
    component: DMUCaseSummaries,
    meta: {
      breadcrumb: [{
        text: 'Discipline Monitoring',
      }]
    }
  },
  {
    path: '/criticalIncidents/caseSummaries',
    name: 'CICaseSummaries',
    component: CICaseSummaries,
    meta: {
      breadcrumb: [{
        text: 'Critical Incidents'
      }]
    }
  },
  {
    path: '/recommendations',
    name: 'OIGRecommendations',
    component: OIGRecommendations,
    meta: {
      breadcrumb: [{
        text: 'OIG Recommendations'
      }]
    }
  },
  {
    path: '/miu/recommendations',
    name: 'MIURecommendations',
    component: MIURecommendations,
    meta: {
      breadcrumb: [{
        text: 'Medical Inspection Recommendations'
      }]
    }
  },
  {
    path: '/scmu/caseSummaries',
    name: 'SCMUCaseSummaries',
    component: SCMUCaseSummaries,
    meta: {
      breadcrumb: [{
        text: 'SMMU Case Summaries'
      }]
    }
  }
  ]
})